// src/services/adminRolesPermissions.js
//
// Domaine Admin — RBAC (rôles & permissions)
// Contrat strict Phase 0.3 — Worker Admin autoritaire.

import { apiFetch, buildQuery } from './adminHttp';

/* ---------- Rôles ---------- */

/** GET /admin/roles */
export async function getRoles() {
  return apiFetch('/admin/roles', { method: 'GET' });
}

/**
 * POST /admin/roles
 * Body : { code, libelle, description? }
 * Super Admin uniquement.
 */
export async function creerRole(payload) {
  return apiFetch('/admin/roles', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/**
 * GET /admin/roles/administrateur?administrateur_id=
 * administrateur_id optionnel (soi-même si absent).
 */
export async function getRolesAdministrateur(administrateurId) {
  const q =
    administrateurId !== undefined && administrateurId !== null && administrateurId !== ''
      ? buildQuery({ administrateur_id: administrateurId })
      : '';
  return apiFetch(`/admin/roles/administrateur${q}`, { method: 'GET' });
}

/**
 * POST /admin/roles/attribuer
 * Body : { administrateur_id, role_id }
 */
export async function attribuerRole(administrateurId, roleId) {
  return apiFetch('/admin/roles/attribuer', {
    method: 'POST',
    body: JSON.stringify({
      administrateur_id: administrateurId,
      role_id: roleId,
    }),
  });
}

/**
 * POST /admin/roles/attribuer-temporaire
 * Body : { administrateur_id, role_id, date_expiration }
 */
export async function attribuerRoleTemporaire(administrateurId, roleId, dateExpiration) {
  return apiFetch('/admin/roles/attribuer-temporaire', {
    method: 'POST',
    body: JSON.stringify({
      administrateur_id: administrateurId,
      role_id: roleId,
      date_expiration: dateExpiration,
    }),
  });
}

/**
 * POST /admin/roles/prolonger
 * Body : { administrateur_id, role_id, date_expiration }
 * Uniquement sur attribution temporaire.
 */
export async function prolongerRole(administrateurId, roleId, dateExpiration) {
  return apiFetch('/admin/roles/prolonger', {
    method: 'POST',
    body: JSON.stringify({
      administrateur_id: administrateurId,
      role_id: roleId,
      date_expiration: dateExpiration,
    }),
  });
}

/**
 * POST /admin/roles/revoquer
 * Body : { administrateur_id, role_id }
 */
export async function revoquerRole(administrateurId, roleId) {
  return apiFetch('/admin/roles/revoquer', {
    method: 'POST',
    body: JSON.stringify({
      administrateur_id: administrateurId,
      role_id: roleId,
    }),
  });
}

/* ---------- Permissions ---------- */

/** GET /admin/permissions */
export async function getPermissions() {
  return apiFetch('/admin/permissions', { method: 'GET' });
}

/**
 * POST /admin/permissions
 * Body : { code, libelle, domaine? }
 */
export async function creerPermission(payload) {
  return apiFetch('/admin/permissions', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/**
 * GET /admin/permissions/role?role_id=
 */
export async function getPermissionsDuRole(roleId) {
  return apiFetch(`/admin/permissions/role${buildQuery({ role_id: roleId })}`, {
    method: 'GET',
  });
}

/**
 * POST /admin/permissions/attacher
 * Body : { role_id, permission_id }
 */
export async function attacherPermission(roleId, permissionId) {
  return apiFetch('/admin/permissions/attacher', {
    method: 'POST',
    body: JSON.stringify({
      role_id: roleId,
      permission_id: permissionId,
    }),
  });
}

/**
 * POST /admin/permissions/detacher
 * Body : { role_id, permission_id }
 */
export async function detacherPermission(roleId, permissionId) {
  return apiFetch('/admin/permissions/detacher', {
    method: 'POST',
    body: JSON.stringify({
      role_id: roleId,
      permission_id: permissionId,
    }),
  });
}

/**
 * GET /admin/permissions/effectives?administrateur_id=
 * Sans ID → soi-même. Autre admin → Super Admin uniquement.
 */
export async function getPermissionsEffectives(administrateurId) {
  const q =
    administrateurId !== undefined && administrateurId !== null && administrateurId !== ''
      ? buildQuery({ administrateur_id: administrateurId })
      : '';
  return apiFetch(`/admin/permissions/effectives${q}`, { method: 'GET' });
}
